
















































import { Component, Vue } from "vue-property-decorator";
import { configuration } from "@/config/host.config";
import { ICurrency } from "@/@types/currency";
import { deleteElement } from "@/api/delite/delite-element";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import AddCurrencyForm from "./currency/add-currency-form.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

@Component({
  components: {
    StandartModal,
    SubmitResetButtonGroop,
    BSwitch,
    AddCurrencyForm,
    cdbtn: ChangeDeliteButtons,
  },
})
class SettingCurrencies extends Vue {
  currencys: Array<ICurrency> = [];

  currency_id = "";
  deleted = false;

  get changeCurrency(): ICurrency | null {
    const currency = this.currencys.find((c) => c._id == this.currency_id);
    return currency ? currency : null;
  }

  mustChange(id: string): void {
    this.currency_id = id;
    this.$nextTick(() => this.$bvModal.show("root-setting-currency-add"));
  }

  mustDeleted(id: string): void {
    const uri = this.deleted
      ? configuration.currency.force
      : configuration.currency.main;
    deleteElement(uri, id)
      .then(() => {
        this.isSuccess(`Settings.currencies.statuses.deleted.${this.deleted}`);
      })
      .catch(() => {
        this.isError();
      });
  }

  isSuccess(text: string): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t(text)),
    });
  }

  isError(text = "alerts.emptyUpdate"): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t(text)),
      type: "warn",
    });
  }

  async updateCurrency(data: Partial<ICurrency>, id: string): Promise<void> {
    const methods = id ? "put" : "post";
    const url = configuration.currency.main;
    const uri = id ? `${url}/${id}` : url;

    try {
      const res = await this.$axios[methods](uri, data);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$bvModal.hide("root-setting-currency-add");
        if (!id) {
          this.currencys.push(res.data);
          return;
        }

        const i = this.currencys.findIndex((c) => c._id == id);
        if (i < 0) return this.crealeCurrencyList();
        const currency = this.currencys[i];
        currency._id = id;
        this.$set(this.currencys, i, currency);
      }
    } catch (e) {
      this.isError();
    }
  }

  async crealeCurrencyList(): Promise<void> {
    const uri = configuration.currency.main;
    try {
      const res = await this.$axios.get(uri);
      if (res.status === 200) {
        this.currencys = res.data;
      }
    } catch (error) {
      console.error(error);
    }
  }

  mounted(): void {
    this.crealeCurrencyList();
  }
}
export default SettingCurrencies;
